import { render, staticRenderFns } from "./bimInput.vue?vue&type=template&id=25ff8cd1&scoped=true&"
import script from "./bimInput.vue?vue&type=script&lang=js&"
export * from "./bimInput.vue?vue&type=script&lang=js&"
import style0 from "./bimInput.vue?vue&type=style&index=0&id=25ff8cd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff8cd1",
  null
  
)

export default component.exports